import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  submit(event) {
    // Form will submit normally
  }

  reset(event) {
    event.preventDefault()
    this.element.reset()
    this.element.requestSubmit()
  }
}
